import React from 'react';
import useSWR from 'swr';
import { useParams } from 'react-router-dom';
import { Button, Card, Spinner, Alert, Row, Col } from 'react-bootstrap';
import styles from '../../../styles.module.css';
import selectEcoById from '../../../services/ecodoppler';
import { formatarIdadeMeses } from '../../../util/utils';
import LaudoCardHeader from '../../../components/laudos/LaudoCardHeader';

export default function EspelhoCongTxt() {
    const { id } = useParams();

    const { data: eco, error, isLoading } = useSWR(
        id ? ['eco', id] : null,
        ([, ecoId]) => selectEcoById(ecoId)
    );

    if (error) {
        return (
            <Alert variant="danger" className="mt-3">
                <Alert.Heading>Erro ao carregar laudo de eco!</Alert.Heading>
                <p>Tente novamente.</p>
            </Alert>
        );
    }

    if (isLoading || !eco) {
        return (
            <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: '80vh' }}
            >
                <Spinner animation="border" variant="dark" size="lg" />
            </div>
        );
    }

    return (
        <>
            <style>
                {`@media print {
          #removeMe {
            display: none !important;
          }

          .page {
            page-break-after: always;
          }

          .page:first-of-type {
            margin-top: 0;
          }

          .page:last-of-type {
            margin-bottom: 0;
            page-break-after: auto;
          }

          /* Remove sombras e bordas do Card na impressão */
          .card {
            border: none !important;
            box-shadow: none !important;
          }
        }`}
            </style>

            <Card className="my-3 shadow-sm border-0">
                <LaudoCardHeader title="ECOCARDIOGRAMA CONGÊNITO" />
                <Card.Body className={styles.titleEspelho}>
                    {/* Cabeçalho do Laudo */}
                    <div className="mb-3">
                        {/* Linha 1: Laudo e Paciente */}
                        <div className="d-flex flex-wrap align-items-center mb-2">
                            <div className="mr-4 me-4">
                                <strong>Laudo:</strong> {eco?.CODECO || '--'}
                            </div>
                            <div>
                                <strong>Paciente:</strong> {eco?.CODPAC || '--'} - {eco?.NOMEPAC || '--'}
                            </div>
                        </div>

                        {/* Linha 2: Dados Pessoais */}
                        <div className="d-flex flex-wrap align-items-center mb-2">
                            <div className="mr-4 me-4">
                                <strong>Dt. Nasc:</strong> {eco?.dataNascFmt || '--'}
                            </div>
                            <div className="mr-4 me-4">
                                <strong>Sexo:</strong> {eco?.Sexo || '--'}
                            </div>
                            <div className="mr-4 me-4">
                                <strong>Idade:</strong> {eco?.DTNPAC ? formatarIdadeMeses(eco?.DTNPAC, eco?.DATAECO) : '--'}
                            </div>
                            <div>
                                <strong>Fone:</strong> {eco?.CELULARPAC || '--'}
                            </div>
                        </div>

                        {/* Linha 3: Convênio e Data Exame */}
                        <div className="d-flex flex-wrap align-items-center mb-2">
                            <div className="mr-4 me-4">
                                <strong>Convênio:</strong> {eco?.SIGLACONV || '--'}
                            </div>
                            <div>
                                <strong>Dt. Exame:</strong> {eco?.dataEcoFmt || '--'}
                            </div>
                        </div>

                        {/* Linha 4: Médicos */}
                        <div className="mt-2">
                            <strong>Realizou:</strong> {eco?.Realizou || '--'} &nbsp;|&nbsp;
                            <strong> Solicitou:</strong> {eco?.Solicitou || '--'}
                        </div>
                    </div>

                    <hr className="my-3" />

                    {/* Campos de Medidas Manual (PS Removido) */}
                    <div className="py-4">
                        {/* Fileira 1 */}
                        <Row className="mb-3 g-3">
                            <Col xs="auto">
                                <span className="fw-bold">PESO: ________</span>
                            </Col>
                            <Col xs="auto">
                                <span className="fw-bold">Altura: _______</span>
                            </Col>
                            <Col xs="auto">
                                <span className="fw-bold">SC: _______</span>
                            </Col>
                            <Col xs="auto">
                                <span className="fw-bold">FC: ___________</span>
                            </Col>
                            <Col xs="auto">
                                <span className="fw-bold">FE: ________</span>
                            </Col>
                        </Row>

                        {/* Fileira 2 */}
                        <Row className="mb-3 g-3">
                            <Col xs="auto">
                                <span className="fw-bold">AE: ________</span>
                            </Col>
                            <Col xs="auto">
                                <span className="fw-bold">AO: _______</span>
                            </Col>
                            <Col xs="auto">
                                <span className="fw-bold">VD: ________</span>
                            </Col>
                            <Col xs="auto">
                                <span className="fw-bold">SIV: ________</span>
                            </Col>
                        </Row>

                        {/* Fileira 3 */}
                        <Row className="mb-3 g-3">
                            <Col xs="auto">
                                <span className="fw-bold">PPVE: ________</span>
                            </Col>
                            <Col xs="auto">
                                <span className="fw-bold">VEd: _______</span>
                            </Col>
                            <Col xs="auto">
                                <span className="fw-bold">VEs: ________</span>
                            </Col>
                        </Row>

                        {/* Observações com área reservada para anotação */}
                        <Row className="mt-4 mb-2">
                            <Col xs={12}>
                                <span className="fw-bold d-block mb-1">Observações:</span>
                                <div
                                    style={{
                                        minHeight: '800px',
                                        // borderBottom: '1px dashed #ccc',
                                        width: '100%'
                                    }}
                                />
                            </Col>
                        </Row>
                    </div>
                </Card.Body>

                {/* Rodapé do Card com o Botão de Imprimir */}
                <Card.Footer id="removeMe" className="bg-white border-0 text-end pb-3 pt-0">
                    <Button variant="primary" onClick={() => window.print()}>
                        Imprimir Espelho
                    </Button>
                </Card.Footer>
            </Card>
        </>
    );
}